import { forwardRef } from 'react';
// Models
import { ICurrentAccount } from 'app/models/Account';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectCurrentAccount } from 'app/store/Accounts/Accounts.selectors';
// X
import {
  DesktopTimePicker as MuiDesktopTimePicker,
  DesktopTimePickerProps as MuiDesktopTimePickerProps
} from '@mui/x-date-pickers';
// Mui
import { TextFieldProps } from '@mui/material';
// Utilities
import { generateAttrForTesting } from 'app/utilities/Utilities';

type Props = {
  name: string;
} & MuiDesktopTimePickerProps

const DesktopTimePicker = forwardRef<HTMLDivElement, Props>(({
  name, ...restProps
}, ref) => {
  const currentAccount:ICurrentAccount | null = useAppSelector(selectCurrentAccount);

  const inputFormat = currentAccount?.settings?.timeFormat || 'hh:mm a';

  return (
    <MuiDesktopTimePicker
      {...restProps}
      ref={ref}
      format={inputFormat}
      slotProps={{
        textField: {
          ...restProps.slotProps?.textField,
          ...generateAttrForTesting('control', 'input', name),
          name,
          fullWidth: true,
          margin: (restProps.slotProps?.textField as TextFieldProps)?.margin || 'normal'
        },
        field: {
          clearable: true
        }
      }}
      sx={{
        ...restProps.sx,
        '& .MuiPickersSectionList-root': {
          width: '100%',
        }
      }}
    />
  );
});

export default DesktopTimePicker;
